import RegisterFromInvitationErrorStep from './Steps/RegisterFromInvitationErrorStep';
import RegisterFromInvitationSuccessStep from './Steps/RegisterFromInvitationSuccessStep';
import RegisterFromInvitationFormStep from './Steps/RegisterFromInvitationFormStep';
import RegisterFromInvitationSmsCodeStep from './Steps/RegisterFromInvitationSmsCodeStep';

export const steps = [
  {
    stepId: 0,
    Component: RegisterFromInvitationErrorStep,
  },
  {
    stepId: 1,
    Component: RegisterFromInvitationFormStep,
  },
  {
    stepId: 2,
    Component: RegisterFromInvitationSmsCodeStep,
  },
  {
    stepId: 3,
    Component: RegisterFromInvitationSuccessStep,
  },
];
